import { teacherServiceURL } from '../endpoint/teacherServiceURL';

export function allTeamsURL() {
  return new URL('teams', teacherServiceURL);
}
export function individualTeamURL(teamId: string) {
  const url = allTeamsURL();
  url.pathname += `/${teamId}`;
  return url;
}

export function teamsMembersURL(teamId: string) {
  const url = individualTeamURL(teamId);
  url.pathname += `/members`;
  return url;
}

export function leaveTeamURL(teamId: string) {
  const url = individualTeamURL(teamId);
  url.pathname += `/leave`;
  return url;
}

export function renameTeamURL(teamId: string) {
  const url = individualTeamURL(teamId);
  url.pathname += `/rename`;
  return url;
}

export function individualTeamMemberURL({
  teamId,
  publicId,
}: {
  teamId: string;
  publicId: string;
}) {
  const url = teamsMembersURL(teamId);
  url.pathname += `/${publicId}`;
  return url;
}

export function changeAccessLevelURL({
  teamId,
  publicId,
}: {
  teamId: string;
  publicId: string;
}) {
  const url = individualTeamMemberURL({ teamId, publicId });
  url.pathname += '/access';
  return url;
}

export function changeRoleURL({
  teamId,
  publicId,
}: {
  teamId: string;
  publicId: string;
}) {
  const url = individualTeamMemberURL({ teamId, publicId });
  url.pathname += '/role';
  return url;
}

export function createTeamInviteUrl(teamId: string) {
  const url = individualTeamURL(teamId);
  url.pathname += `/invites`;
  return url;
}

export function teamInviteInfoUrl({ inviteCode }: { inviteCode: string }) {
  const url = allTeamsURL();
  url.pathname += `/invites/info/${inviteCode}`;
  return url;
}

export function acceptTeamInviteUrl({ inviteCode }: { inviteCode: string }) {
  const url = allTeamsURL();
  url.pathname += `/invites/accept/${inviteCode}`;
  return url;
}

export function transferOwnershipUrl({
  teamId,
  newOwnerPublicId,
}: {
  teamId: string;
  newOwnerPublicId: string;
}) {
  const url = individualTeamURL(teamId);
  url.pathname += `/transfer-ownership/${newOwnerPublicId}`;
  return url;
}

export function updateTeamSettingsUrl({ teamId }: { teamId: string }) {
  const url = individualTeamURL(teamId);
  url.pathname += `/settings`;
  return url;
}
